module.exports = __webpack_public_path__ + "img/people19.d6de6507.png";